import { useEffect, useState } from "react";
import Button from "../atoms/button";

const ManageRolesModal = ({ open, staffUser, currentUser, onClose, onSave }) => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isMaster, setIsMaster] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setIsAdmin(Boolean(staffUser?.roles?.includes("admin")));
        setIsMaster(Boolean(staffUser?.roles?.includes("master")));
    }, [staffUser]);

    if (!open || !staffUser) return null;

    const isSelf = staffUser.email === currentUser.email;

    const handleSave = async () => {
        setSaving(true);
        await onSave(staffUser, { admin: isAdmin, master: isMaster });
        setSaving(false);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            <div className="w-96 rounded-lg border border-[#d59106] bg-[#1c1917] p-6">
                <h3 className="mb-1 text-lg">{staffUser.name}</h3>
                <p className="mb-4 text-sm opacity-80">{staffUser.email}</p>
                <div className="mb-6 flex flex-col gap-3">
                    <label className="flex items-center gap-2">
                        <input type="checkbox" checked={isAdmin} onChange={() => setIsAdmin(!isAdmin)} />
                        Admin
                    </label>
                    <label className="flex items-center gap-2">
                        <input type="checkbox" checked={isMaster} onChange={() => setIsMaster(!isMaster)}
                            disabled={isSelf && staffUser.roles.includes("master")} />
                        Master
                    </label>
                    {isSelf && staffUser.roles.includes("master") ? (
                        <p className="text-xs opacity-70">Você não pode revogar seu próprio acesso master.</p>
                    ) : null}
                </div>
                <div className="flex justify-end gap-3">
                    <Button classes="bg-gray-600 hover:bg-gray-700" click={onClose}>Cancelar</Button>
                    <Button classes="bg-[#d59106] hover:bg-orange-500" click={handleSave} disabled={saving}>Salvar acesso</Button>
                </div>
            </div>
        </div>
    );
};

export default ManageRolesModal;
